module.exports = {
      id: "biggan-chinta-usage",
      viewBox: "0 0 156 40",
      url: "/" + "sprite-326d1762f7ed1f924194ae9c5468ee69.svg#biggan-chinta",
      toString: function () {
        return this.url;
      }
    }